<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="67.786" height="79.384" viewBox="0 0 67.786 79.384">
		<g id="" transform="translate(0.5 1.5)">
			<path
				id=""
				d="M65.286,70.085a5.8,5.8,0,0,1-5.8,5.8H7.3a5.8,5.8,0,0,1-5.8-5.8V6.3A5.8,5.8,0,0,1,7.3.5H44.991l20.3,20.3Z"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="4"
			/>
			<path
				id=""
				data-name="Vector 1238"
				d="M11.483,3.578C3.981,5.8,35.261,43.495,38.6,34.869S-2.49,37.363,4.826,43.495,18.985,1.355,11.483,3.578Z"
				transform="translate(12.05 14.414)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="4"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'PdfIcon',
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
};
</script>
